import { Badge } from '@amzn/awsui-components-console';

/** Marks a result or run from a rule in DRY_RUN status: it did not count toward any verdict. */
export function DryRunBadge() {
  return <Badge color="grey">Dry Run</Badge>;
}
